import Model, {
  attr,
  hasMany,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type Heading from 'linced-admin/models/school-options/heading';

// Proto: schools.OptionGroup.
export default class Group extends Model {
  declare [Type]: 'school-options/group';

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('string', { defaultValue: '' })
  declare icon: string;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('boolean', { defaultValue: false })
  declare heroOnly: boolean;

  @hasMany('school-options/heading', { inverse: 'groupId', async: true })
  declare headings: AsyncHasMany<Heading>;
}
